import Excel from "exceljs";

export default async function createExcelFile(columns, fileName) {
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet("template");
  worksheet.columns = columns;
  const buffer = await workbook.xlsx.writeBuffer();
  let blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.xlsx`;
  link.click();
  URL.revokeObjectURL(link.href);
}
